import { useEffect, useRef } from "react";

const CONTAINER_ID = "container-9a875e0b5781b82416537a779cdf53f9";
const SCRIPT_SRC =
  "https://pl31209141.profitableratecpmnetwork.com/9a875e0b5781b82416537a779cdf53f9/invoke.js";

/**
 * Adsterra native banner. The network's snippet is a bare <script> + <div>,
 * so the script is injected imperatively (not via a JSX <script> tag) and
 * removed on unmount to avoid double-invoking it if this component
 * re-mounts (e.g. React StrictMode, client-side route changes).
 */
export default function NativeAd() {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.setAttribute("data-cfasync", "false");
    script.src = SCRIPT_SRC;
    containerRef.current?.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div className="native-ad">
      <span className="native-ad__label">Advertisement</span>
      <div id={CONTAINER_ID} ref={containerRef} />
    </div>
  );
}
